import * as React from 'react';
import { Platform } from 'react-native';
import {
    BodyMediumEmphasized,
    BodyMediumRegular,
    BodySmallRegular,
    H5Emphasized,
    HandIcon,
    Icon,
    isWeb,
    LockIcon,
    PointerIcon,
    View,
    XStack,
    YStack,
} from 'smoothie';

import KycButton from './KycButton';

interface ExplainerProps {
    onPressNext: () => void;
}

const Explainer = ({ onPressNext }: ExplainerProps) => {
    const shadowStyle = Platform.select({
        ios: {
            shadowColor: 'rgba(0, 0, 0, 0.05)',
            shadowOffset: {
                width: 0,
                height: 5,
            },
            shadowOpacity: 0.25,
            shadowRadius: 10,
        },
        android: {
            elevation: 5,
        },
    });

    return (
        <YStack
            alignItems="center"
            flex={1}
            justifyContent={isWeb ? 'flex-start' : 'space-between'}
        >
            <View>
                <View
                    alignSelf="center"
                    padding={20}
                    borderRadius={20}
                    backgroundColor="$gray1000"
                    marginTop={30}
                    marginBottom={30}
                    style={{ ...shadowStyle }}
                >
                    <Icon icon={LockIcon} color="$white" size={40} />
                </View>
                <H5Emphasized textAlign="center" marginBottom={14}>
                    We&apos;re going to ask you a few{'\n'}verification
                    questions
                </H5Emphasized>
                <BodyMediumRegular color="$gray900" textAlign="center">
                    We&apos;re required to do this in order to verify your{'\n'}
                    identity. This won&apos;t impact your credit score.
                </BodyMediumRegular>
            </View>

            <YStack width="100%" gap={16}>
                <YStack
                    backgroundColor="$gray100"
                    borderRadius={20}
                    padding={16}
                    gap={12}
                >
                    <XStack alignItems="center" gap={8}>
                        <Icon icon={HandIcon} color="$gray1100" size={16} />
                        <BodyMediumEmphasized color="$gray1000">
                            Just a head&apos;s up!
                        </BodyMediumEmphasized>
                    </XStack>
                    <BodySmallRegular color="$gray1000">
                        To help the government fight the funding of terrorism
                        and money laundering activities, Federal law requires
                        all financial institutions to obtain, verify, and record
                        information that identifies each customer that opens an
                        account.
                    </BodySmallRegular>
                    <XStack alignItems="center" gap={8}>
                        <Icon icon={PointerIcon} color="$gray1100" size={16} />
                        <BodyMediumEmphasized color="$gray1000">
                            What this means for you
                        </BodyMediumEmphasized>
                    </XStack>
                    <BodySmallRegular color="$gray1000">
                        When you open an account, we will ask you your name,
                        address, date of birth and other information that will
                        allow us to identify you. We may also ask to see your
                        driver&apos;s license or other identifying information.
                    </BodySmallRegular>
                </YStack>
                <KycButton
                    onPress={() => {
                        onPressNext();
                    }}
                    hideSecureText
                />
            </YStack>
        </YStack>
    );
};

export default Explainer;
